import { Creator } from '../../../../common/models/creator.model';
import { ActionList } from '../../../../common/models/action-list.model';
import { Icon } from '../../../../../core/common';

export enum DelegationStatus {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  REVOKED = 'revoked',
}

export enum DelegationTaskScope {
  // ALL = 'all',
  DIRECT = 'direct',
}

export interface Delegation {
  id: number;
  reason: string;
  started_at: string;
  ended_at: string;
  state: {
    label: string;
    value: DelegationStatus;
  };
  delegate: Creator;
  delegator: Creator;
  flow_templates: FlowTemplate[];
  created_at: string;
}

export interface FlowTemplate {
  id: number;
  name: string;
  description: string;
  is_triggable: boolean;
  category: Category;
  permissions: Permission[];
  icon?: Icon;
}

export interface Category {
  id: number;
  name: string;
  color: string;
}

export interface Permission {
  action: string;
}

export interface DelegationTableRow extends Delegation {
  statusBadgeClass: string;
  actionMenuItems: ActionList[];
}

export interface DualLanguageText {
  en: string;
  ar: string;
}

export interface DelegationDetails extends Delegation {
  task_scope: DelegationTaskScope;
  delegator: Creator;
  translations: {
    reason: DualLanguageText;
  };
}

export interface DelegationFormPayload {
  delegate_id: number;
  started_at: string | null;
  ended_at: string;
  reason: DualLanguageText;
  flow_template_ids: number[];
  task_scope: DelegationTaskScope;
}
